import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import '../about/AboutPage.css'
import './PrivacyPolicyPage.css'
import quokkaImg from '../images/quokka.png'

const SUPPORT_EMAIL = 'info@quokka.kg'
const UPDATED_AT = '1 ноября 2026'
const OWNER = 'ИП Келдибеков Омурзак Келдибекович'
const ADDRESS = 'Кыргызская Республика, г. Бишкек, Свердловский р-н, ж/м Бакай-Ата, ул. Сыргак 15'
const PHONES = [
  { display: '0550 909 505', href: 'tel:+996550909505' },
  { display: '0506 905 509', href: 'tel:+996506905509' },
]

function PrivacyPolicyPage() {
  useEffect(() => {
    const prevHtmlOverflow = document.documentElement.style.overflow
    const prevBodyOverflow = document.body.style.overflow
    const root = document.getElementById('root')
    const prevRootOverflow = root?.style.overflow
    const prevRootHeight = root?.style.height
    const prevRootMinHeight = root?.style.minHeight

    document.documentElement.style.overflow = 'auto'
    document.body.style.overflow = 'visible'
    if (root) {
      root.style.overflow = 'visible'
      root.style.height = 'auto'
      root.style.minHeight = '100vh'
    }

    window.scrollTo(0, 0)

    return () => {
      document.documentElement.style.overflow = prevHtmlOverflow
      document.body.style.overflow = prevBodyOverflow
      if (root) {
        root.style.overflow = prevRootOverflow || ''
        root.style.height = prevRootHeight || ''
        root.style.minHeight = prevRootMinHeight || ''
      }
    }
  }, [])

  return (
    <div className="ql qp">
      <header className="ql-nav">
        <div className="ql-nav-inner">
          <Link className="ql-brand" to="/" aria-label="Quokka">
            <img src={quokkaImg} alt="" className="ql-brand-mark" />
            <span>Quokka</span>
          </Link>
        </div>
      </header>

      <main className="qp-main">
        <article className="qp-article">
          <p className="qp-kicker">Юридическая информация</p>
          <h1>Политика конфиденциальности Quokka</h1>
          <p className="qp-meta">Дата последнего обновления: {UPDATED_AT}</p>

          <p>
            Настоящая Политика конфиденциальности (далее — «Политика») разработана в соответствии с
            Законом Кыргызской Республики № 58 «Об информации персонального характера» от 14 апреля
            2008 года и иными нормативными правовыми актами Кыргызской Республики.
          </p>
          <p>
            Политика определяет порядок сбора, обработки, хранения, передачи и защиты персональных
            данных при использовании цифрового сервиса <strong>Quokka</strong> (далее — «Сервис»),
            включая веб-сайт, онлайн-витрины бизнесов, панель управления и Telegram-приложение (Mini App).
          </p>
          <p>
            Регистрируясь в Сервисе, оформляя заказ на странице бизнеса или продолжая использовать
            Сервис, пользователь (субъект персональных данных) выражает свое добровольное и
            осознанное согласие на обработку своих персональных данных на условиях настоящей Политики.
          </p>

          <section>
            <h2>Юридическая информация об операторе Сервиса</h2>
            <p>
              Владелец Сервиса: <strong>{OWNER}</strong>
            </p>
            <p>
              Адрес: <strong>{ADDRESS}</strong>
            </p>
            <p>
              Телефон:{' '}
              {PHONES.map((phone, index) => (
                <span key={phone.href}>
                  {index > 0 ? ', ' : null}
                  <a href={phone.href}>{phone.display}</a>
                </span>
              ))}
            </p>
            <p>
              Email:{' '}
              <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
            </p>
          </section>

          <section>
            <h2>1. Общие положения и статус сторон</h2>
            <p>
              Quokka — это облачная платформа для создания онлайн-каталогов магазинов и сервисов
              аренды (проката), ведения складского учета, бронирования по периодам, оформления
              продаж и управления заказами.
            </p>
            <p>
              В соответствии с законодательством Кыргызской Республики роли при обработке
              персональных данных распределяются следующим образом:
            </p>
            <ul>
              <li>
                в отношении данных <strong>владельцев и сотрудников бизнесов</strong> (операторов){' '}
                держателем (обладателем) массива персональных данных выступает владелец Сервиса —{' '}
                <strong>{OWNER}</strong>;
              </li>
              <li>
                в отношении данных <strong>покупателей и арендаторов (клиентов бизнесов)</strong>,
                оформляющих заказы на покупку или аренду через витрину конкретного бизнеса,
                самостоятельным держателем массива персональных данных является соответствующий{' '}
                <strong>владелец бизнеса</strong> (продавец или арендодатель), а Сервис Quokka
                выступает в роли технического обработчика, предоставляющего программную
                инфраструктуру.
              </li>
            </ul>
          </section>

          <section>
            <h2>2. Какие данные мы собираем и обрабатываем</h2>
            <p>
              Мы собираем только те данные, которые необходимы для работы Сервиса и выполнения
              обязательств перед пользователями.
            </p>

            <h3>2.1. Данные владельцев и сотрудников бизнесов:</h3>
            <ul>
              <li>имя (отображаемое имя оператора);</li>
              <li>адрес электронной почты (используется для входа и отправки кодов подтверждения);</li>
              <li>пароль в зашифрованном виде (криптографический хеш — исходный пароль не хранится);</li>
              <li>идентификатор аккаунта Telegram (Telegram ID) при входе через Telegram;</li>
              <li>
                данные бизнеса и филиалов: название, тип бизнеса («Магазин» или «Аренда»), ссылка
                (доменное имя витрины), логотип, баннеры, расписание работы, координаты филиалов и
                ID подключенного Telegram-канала;
              </li>
              <li>
                реквизиты для подключения онлайн-оплаты и фискализации (при их настройке бизнесом):
                ИНН, наименование организации, адрес торговой точки и технические ключи интеграции.
              </li>
            </ul>

            <h3>2.2. Данные покупателей и арендаторов (клиентов бизнесов):</h3>
            <p>При оформлении заказа или бронирования аренды через онлайн-каталог бизнеса собираются:</p>
            <ul>
              <li>имя клиента (покупателя или арендатора);</li>
              <li>
                номер телефона (WhatsApp) — используется для подтверждения заказа одноразовым кодом
                (OTP) и для связи бизнеса с клиентом;
              </li>
              <li>зона и адрес доставки (при выборе доставки);</li>
              <li>
                состав заказа, выбранные товары или предметы аренды, количество, примененные
                промокоды и подарки;
              </li>
              <li>
                период аренды — выбранные дата и время начала (выдачи) и окончания (возврата)
                аренды, а также длительность тарифного периода (при оформлении заказа в бизнесе
                типа «Аренда»);
              </li>
              <li>комментарий к заказу (при наличии);</li>
              <li>информация о статусе оплаты и сумме задолженности по заказу (если применимо).</li>
            </ul>

            <h3>2.3. Технические данные и данные аналитики:</h3>
            <ul>
              <li>
                IP-адрес устройства посетителя и время посещения (используются для подсчета
                уникальных просмотров витрины бизнеса, карточек товаров, переходов по ссылкам и
                защиты от автоматических накруток);
              </li>
              <li>
                данные локального хранилища браузера (<code>localStorage</code> и{' '}
                <code>sessionStorage</code>) — используются исключительно для сохранения товаров и
                выбранных периодов аренды в корзине, выбранной темы оформления и сессии авторизации.
              </li>
            </ul>
          </section>

          <section>
            <h2>3. Данные о товарах, аренде и коммерческой деятельности</h2>
            <p>Владельцы бизнесов размещают в Сервисе коммерческую информацию:</p>
            <ul>
              <li>
                каталог товаров и предметов аренды, категории, цены, тарифные периоды аренды
                (минуты, часы, сутки), фотографии и характеристики (размеры, цвета);
              </li>
              <li>
                складские остатки, график занятости и доступности товаров по датам и времени (для
                бизнесов типа «Аренда») и историю движения товаров по филиалам;
              </li>
              <li>историю продаж, арендных заказов, возвратов и списаний;</li>
              <li>учет внутренних расходов бизнеса;</li>
              <li>условия акций, скидок и промокодов.</li>
            </ul>
            <p>
              Указанные данные принадлежат владельцу соответствующего бизнеса и используются
              Сервисом исключительно для обеспечения работы его бизнеса и формирования внутренней
              отчетности.
            </p>
          </section>

          <section>
            <h2>4. Цели и правовые основания обработки данных</h2>
            <p>Обработка персональных данных осуществляется в следующих целях:</p>
            <ul>
              <li>регистрация, авторизация и предоставление доступа к личному кабинету бизнеса;</li>
              <li>
                подтверждение контактных данных пользователей с помощью одноразовых кодов (по
                электронной почте и через WhatsApp);
              </li>
              <li>
                оформление заказов на покупку и бронирование аренды, проверка доступности товаров
                на выбранный период, обработка и отслеживание статуса заказов;
              </li>
              <li>мгновенное уведомление сотрудников филиала о новых заказах через Telegram;</li>
              <li>формирование платежных QR-кодов и электронных фискальных чеков (при подключении);</li>
              <li>предоставление владельцу бизнеса статистики продаж, аренды, расходов и посещаемости;</li>
              <li>предотвращение мошенничества, спама и несанкционированного доступа;</li>
              <li>оказание технической поддержки пользователям.</li>
            </ul>
            <p>
              Правовым основанием обработки данных является согласие субъекта персональных данных, а
              также необходимость исполнения пользовательского соглашения и оформления заказа на
              покупку или аренду (ст. 6 и ст. 9 Закона КР «Об информации персонального характера»).
            </p>
          </section>

          <section>
            <h2>5. Заказы и взаимодействие клиента с бизнесом</h2>
            <p>
              При оформлении заказа на странице бизнеса данные покупателя или арендатора передаются
              непосредственно владельцу и уполномоченным сотрудникам этого бизнеса.
            </p>
            <p>Владелец бизнеса самостоятельно несет ответственность за:</p>
            <ul>
              <li>
                достоверность описания товаров, цен, тарифов и условий продажи или предоставления
                имущества в аренду (прокат);
              </li>
              <li>
                связь с клиентом, сборку, передачу (доставку) товара и прием арендованного
                имущества обратно по окончании срока аренды;
              </li>
              <li>прием оплаты, возврат средств и выдачу кассовых чеков;</li>
              <li>
                соблюдение гражданского законодательства Кыргызской Республики, законодательства о
                защите прав потребителей и о персональных данных в отношении своих клиентов.
              </li>
            </ul>
          </section>

          <section>
            <h2>6. Платежи и фискализация</h2>
            <p>
              Сервис Quokka не собирает и не хранит реквизиты банковских карт покупателей (номера
              карт, CVV/CVC-коды, пароли).
            </p>
            <p>
              При выборе онлайн-оплаты (например, через платежную систему <strong>O!Деньги / O!Trade</strong>{' '}
              или QR-платежи) формирование счета и проведение оплаты осуществляются напрямую через
              защищенные шлюзы соответствующей платежной организации. Сервис получает от платежного
              провайдера только статус оплаты и идентификатор транзакции.
            </p>
            <p>
              При подключении бизнесом сервиса онлайн-кассы (например, <strong>eKassa</strong>) в
              систему фискализации передаются только данные о составе заказа и сумме расчета,
              необходимые для формирования фискального чека в соответствии с налоговым
              законодательством КР.
            </p>
          </section>

          <section>
            <h2>7. Сторонние сервисы и трансграничная передача данных</h2>
            <p>
              Для обеспечения бесперебойной работы Сервиса мы используем проверенные внешние
              технические сервисы, которым могут передаваться минимально необходимые данные:
            </p>
            <ul>
              <li>
                <strong>Telegram</strong> — для входа в панель управления (Mini App) и отправки
                уведомлений о заказах в рабочие каналы филиалов бизнеса;
              </li>
              <li>
                <strong>WhatsApp Business API (Meta)</strong> — исключительно для отправки покупателю
                одноразового кода подтверждения номера телефона при оформлении заказа;
              </li>
              <li>
                <strong>Сервис почтовых рассылок (Brevo)</strong> — для отправки кодов подтверждения
                на электронную почту владельца бизнеса при регистрации и входе;
              </li>
              <li>
                <strong>Google Cloud Storage</strong> — для надежного хранения загруженных
                изображений товаров, логотипов и баннеров бизнесов.
              </li>
            </ul>
            <p>
              Поскольку серверы отдельных инфраструктурных партнеров (Google Cloud, Meta, Telegram,
              Brevo) могут располагаться за пределами Кыргызской Республики, использование Сервиса
              означает согласие пользователя на трансграничную передачу соответствующих технических
              и контактных данных в объеме, необходимом для работы указанных функций (в соответствии
              со ст. 25 Закона КР «Об информации персонального характера»).
            </p>
            <p>Мы не продаем и не передаем персональные данные рекламным сетям или брокерам данных.</p>
          </section>

          <section>
            <h2>8. Аналитика и алгоритмы прогнозирования</h2>
            <p>
              Для помощи владельцам бизнесов в Сервисе используются встроенные математические
              модели и алгоритмы машинного обучения, которые на основе истории продаж бизнеса
              рассчитывают статистику и прогноз спроса на следующие периоды.
            </p>
            <p>
              Такие расчеты выполняются автоматически внутри системы по обезличенным показателям
              продаж и не предполагают передачи персональных данных покупателей во внешние сервисы
              искусственного интеллекта.
            </p>
          </section>

          <section>
            <h2>9. Сроки хранения и защита данных</h2>
            <p>
              Персональные данные хранятся в течение всего срока использования Сервиса пользователем
              либо до момента достижения целей их обработки или отзыва согласия субъектом данных,
              если более длительный срок не предусмотрен законодательством Кыргызской Республики.
            </p>
            <ul>
              <li>
                одноразовые коды подтверждения (OTP) для WhatsApp действуют 5 минут, для электронной
                почты — 30 минут, после чего утрачивают силу;
              </li>
              <li>пароли операторов хранятся исключительно в виде необратимого криптографического хеша;</li>
              <li>передача данных между браузером и сервером осуществляется по защищенному протоколу HTTPS;</li>
              <li>
                доступ к базе данных строго ограничен и защищен паролями, межсетевыми экранами и
                механизмами авторизации по токенам (JWT).
              </li>
            </ul>
          </section>

          <section>
            <h2>10. Права субъекта персональных данных</h2>
            <p>
              В соответствии с Законом Кыргызской Республики «Об информации персонального характера»
              пользователь имеет право:
            </p>
            <ul>
              <li>
                получать информацию о наличии у оператора его персональных данных и знакомиться с
                ними;
              </li>
              <li>
                требовать уточнения (изменения), блокирования или уничтожения своих персональных
                данных в случае, если они являются неполными, устаревшими или неточными;
              </li>
              <li>
                отозвать свое согласие на обработку персональных данных и запросить удаление
                учетной записи;
              </li>
              <li>
                защищать свои права и законные интересы, в том числе путем обращения в
                уполномоченный государственный орган по персональным данным КР (Государственное
                агентство по защите персональных данных при Кабинете Министров КР).
              </li>
            </ul>
            <p>
              Для реализации своих прав, изменения данных или удаления аккаунта направьте запрос на
              электронную почту{' '}
              <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> или свяжитесь с нами по
              указанным ниже телефонам. Запросы рассматриваются в сроки, установленные
              законодательством Кыргызской Республики (не более 7 рабочих дней).
            </p>
          </section>

          <section>
            <h2>11. Обязанности пользователей</h2>
            <p>Пользователь Сервиса обязуется:</p>
            <ul>
              <li>указывать достоверные контактные данные при регистрации и оформлении заказа;</li>
              <li>обеспечивать сохранность своих учетных данных (пароля и кодов подтверждения);</li>
              <li>не использовать Сервис для противоправной деятельности или рассылки спама;</li>
              <li>
                при использовании Сервиса в качестве владельца бизнеса — обеспечивать
                конфиденциальность полученных данных покупателей и использовать их исключительно для
                выполнения заказов.
              </li>
            </ul>
          </section>

          <section>
            <h2>12. Изменение Политики конфиденциальности</h2>
            <p>
              Мы можем обновлять настоящую Политику по мере развития функциональности Сервиса или при
              изменении требований законодательства Кыргызской Республики. Актуальная редакция всегда
              доступна на странице <strong>/pages/privacy</strong> с указанием даты последнего
              обновления.
            </p>
          </section>

          <section>
            <h2>13. Контактная информация</h2>
            <p>По всем вопросам, связанным с обработкой и защитой персональных данных:</p>
            <p>
              <strong>Quokka</strong>
            </p>
            <p>
              Владелец: <strong>{OWNER}</strong>
            </p>
            <p>
              Адрес: <strong>{ADDRESS}</strong>
            </p>
            <p>
              Телефон:{' '}
              {PHONES.map((phone, index) => (
                <span key={phone.href}>
                  {index > 0 ? ', ' : null}
                  <a href={phone.href}>{phone.display}</a>
                </span>
              ))}
            </p>
            <p>
              Email:{' '}
              <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
            </p>
            <p>Дата публикации: {UPDATED_AT}</p>
          </section>
        </article>
      </main>

      <footer className="ql-footer">
        <div className="ql-footer-inner">
          <strong>Quokka</strong>
          <p>Простой сервис для онлайн-каталога, учёта товаров, продаж и аренды.</p>
          <div className="qp-footer-links">
            <Link className="qp-footer-link" to="/">
              На главную
            </Link>
            <Link className="qp-footer-link" to="/pages/terms">
              Оплата и возврат
            </Link>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default PrivacyPolicyPage
